<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="sm" @click="showModal = true">
            เพิ่มใบเสร็จใหม่</base-button
          >
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="receipts"
      >
        <template slot="columns">
          <th>วันที่</th>
          <th>ชื่อสกุล</th>
          <th>เบอร์โทร</th>
          <th>ประเภทงานที่ทำ</th>
          <th>บริษัทประกัน</th>
          <th>ยี่ห้อ</th>
          <th>ทะเบียน</th>
          <th>ยอดรวม</th>
          <th>ไฟล์</th>
        </template>

        <template slot-scope="{ row }">
          <th
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ formatDate(row.created_at) }}
          </th>
          <th
            scope="td-bold"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <div class="media align-items-center">
              <div class="media-body cutname">
                <span class="name mb-0 text-sm"
                  >{{ row.name }}
                  <span v-if="row.type == 1">(กลุ่ม)</span></span
                >
              </div>
            </div>
          </th>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ row.tel }}
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="row.insurance_price"
              >{{ row.insurance_type_name }}
            </span>
            <span v-if="row.wsu_price && row.insurance_price"> + </span>
            <span v-if="row.wsu_price">พรบ</span>
            <span v-if="row.wsu_price && row.tax_price"> + </span>
            <span v-if="row.tax_price && row.insurance_price && !row.wsu_price">
              +
            </span>
            <span v-if="row.tax_price">ภาษี</span>
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="row.insurance_company_name !== 'OTHER'">
              {{ row.insurance_price ? row.insurance_company_name : "" }}
            </span>
            <span v-else>
              {{ row.if_other_insurance_company }}
            </span>
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ row.car_type === "car" ? row.brand_name : "มอเตอร์ไซต์" }}
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ row.license_plate }}
          </td>
          <td
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <!-- {{
              (
                (row.wsu_price ? parseInt(row.wsu_price) : 0) +
                (row.insurance_price ? parseInt(row.insurance_price) : 0) +
                (row.tax_price ? parseInt(row.tax_price) : 0) +
                (row.other_price ? parseInt(row.other_price) : 0) +
                (row.is_inspected && row.car_type === "car" ? 200 : 60)
              ).toLocaleString()
            }} -->
            {{
              (
                (row.wsu_price ? parseInt(row.wsu_price) : 0) +
                (row.insurance_price ? parseInt(row.insurance_price) : 0) +
                (row.tax_price ? parseInt(row.tax_price) : 0) +
                (row.other_price ? parseInt(row.other_price) : 0) +
                (row.inspect_price_car ? parseInt(row.inspect_price_car) : 0) +
                (row.inspect_price_motorcycle
                  ? parseInt(row.inspect_price_motorcycle)
                  : 0)
              ).toLocaleString()
            }}
            ({{
              row.real_price ? Number(row.real_price).toLocaleString() : ""
            }})
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="!row.is_cancelled">
              <a href="#" @click="getPDF(row.id, row.type, row.receipt)">
                <img
                  src="/img/brand/ic_pdf.png"
                  width="24"
                  height="24"
                  alt="ใบเสร็จ"
                />
                <!-- RCP{{ row.receipt }}.pdf -->
              </a></span
            >

            <!-- <span v-else>{{ row.note }} </span> -->
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
    <Modal :show="showModal">
      <div class="col text-center">
        <h2>เลือกประเภทบิลที่ต้องการ</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        >
          <span>×</span>
        </button>
        <div class="row justify-content-around mt-4">
          <router-link to="receiptAddNew">
            <base-button type="info" size="md"
              >บิลเดี่ยว</base-button
            ></router-link
          >
          <router-link to="receiptAddNewGroup">
            <base-button type="warning" size="md">บิลกลุ่ม</base-button>
          </router-link>
        </div>
      </div></Modal
    >
    <Modal :show="showCancelModal">
      <div class="col text-center">
        <h2>ใส่เหตุผลที่ต้องการยกเลิกใบเสร็จ</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showCancelModal = false"
        >
          <span>×</span>
        </button>
        <div class="col-12 mt-3">
          <base-input
            alternative=""
            placeholder="เหตุผล"
            type="text"
            input-classes="form-control-alternative"
            v-model="cancelled.note"
          />
        </div>
        <div class="row justify-content-around mt-4">
          <base-button type="primary" size="md" @click="cancel()"
            >ยืนยัน</base-button
          >
          <base-button type="warning" size="md" @click="showCancelModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
  </div>
</template>
<script>
import Modal from "../../components/Modal";
import axios from "axios";
import kickMixin from "../../mixins/kickMixin";
import moment from "moment";

moment.locale("th");

export default {
  name: "receipt-table",
  mixins: [kickMixin],
  components: {
    Modal,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    receipts: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  computed: {
    calculateTotal() {
      return this.receipts.length;
    },
  },
  methods: {
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;

      // let parsedDate = Date.parse(date);
      // let newDate = new Date(parsedDate);
      // let day = newDate.getDate();
      // let month = newDate.getMonth();
      // let year = newDate.getYear();

      // let hour = newDate.getHours();
      // let min = newDate.getMinutes();
      // let sec = newDate.getSeconds();
      // return (
      //   day +
      //   " " +
      //   monthNames[month] +
      //   " " +
      //   (year + 543 + 1900) +
      //   " " +
      //   hour +
      //   ":" +
      //   min +
      //   ":" +
      //   sec
      // );
      return day + " " + month + " " + year;
    },
    goTo(type, key, receipt) {
      if (localStorage.level == 999) {
        if (type == 0) {
          let routeData = this.$router.resolve({ path: "/receipt/" + key });
          window.open(routeData.href, "_blank");
        } else {
          let routeData = this.$router.resolve({
            path: "/receiptGroup/" + receipt,
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
    cancel() {
      var localApp = this;
      let finalUrl =
        localApp.selectedReceipt !== ""
          ? "/api/receipt/cancel/" +
            localApp.selectedReceipt
          : "/api/receiptGroup/cancel/" +
            localApp.selectedReceiptGroup;
      axios
        .patch(finalUrl, localApp.cancelled, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            window.location.reload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    getPDF(id, type, receipt) {
      if (type === 0) {
        window.open(
          "/api/receipt/getPDF/" + id,
          "_blank"
        );
        // axios
        //   .get("/api/receipt/getPDF/" + id, {
        //     headers: {
        //       Authorization: "Bearer " + localStorage.token,
        //     },
        //     responseType: "blob",
        //   })
        //   .then(function(response) {
        //     const url = window.URL.createObjectURL(new Blob([response.data]));
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", "RCP" + receipt + ".pdf");
        //     document.body.appendChild(link);
        //     link.click();
        //   })
        //   .catch(function(error) {
        //     alert(error);
        //   });
      } else {
        window.open(
          "/api/receipt/getPDFgroup/" + receipt,
          "_blank"
        );
        // axios
        //   .get("/api/receipt/getPDFgroup/" + receipt, {
        //     headers: {
        //       Authorization: "Bearer " + localStorage.token,
        //     },
        //     responseType: "blob",
        //   })
        //   .then(function(response) {
        //     const url = window.URL.createObjectURL(new Blob([response.data]));
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", "RCP" + receipt + ".pdf");
        //     document.body.appendChild(link);
        //     link.click();
        //   })
        //   .catch(function(error) {
        //     alert(error);
        //   });
      }
    },
  },
  data() {
    return {
      showCancelModal: false,
      showModal: false,
      lvl: 0,
      cancelled: {
        note: "",
      },
      selectedReceipt: "",
      selectedReceiptGroup: "",
    };
  },
  created: function() {
    this.lvl = localStorage.level;
  },
};
</script>
<style scoped>
.cancelled {
  color: red;
}
.pointer {
  cursor: pointer;
}
.none {
  display: none !important;
}
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
.cutname {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bg-installment {
  background-color: #f6eec4;
}
</style>
